export default __webpack_public_path__ + "assets/images/Market-Leader-03b78205c4e78a8d4f90edbb9eede09f.svg";